import * as React from 'react';
import { SVGProps } from 'react';

const SvgHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M13.54 11.18a6.374 6.374 0 0 1 5.9-3.96c2.96 0 5.44 2.01 6.16 4.74"
    />
    <path
      fill={props.fill}
      d="M10.61 3.36 7.09 6.88l4.38 4.42 7.98.9-8.84-8.84Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M18.73 3v4.22m6.11-1.97-2.98 2.99"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M27.03 17.42s5.06 14.4.76 18.7C22.76 41.15 6 32.21 6 21.64c0-9.86 7.86-13 15.17-8.35"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M11.2 24.14c7.05 0 4.23-8.46 11.6-11.46 4.67-1.9 10.57.66 10.57.66l-.62 4.22s-4.09-1.54-7.37-.13c-3.28 1.41-3.94 5.76-2.99 8.61l.42 1.25"
    />
  </svg>
);

export default SvgHeart;
